import theme from "@/theme";
import { FC } from "react";

interface CheckboxActiveSvgProps {
  size?: number;
}

const CheckboxActiveSvg: FC<CheckboxActiveSvgProps> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="18" height="18" rx="5" fill={theme.palette.custom.mainBlue} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0798 6.67085C15.3076 6.89866 15.3076 7.26801 15.0798 7.49581L10.0714 12.5042C9.388 13.1876 8.27997 13.1876 7.59655 12.5042L5.50484 10.4125C5.27703 10.1847 5.27703 9.81533 5.50484 9.58752C5.73264 9.35972 6.10199 9.35972 6.3298 9.58752L8.42151 11.6792C8.64931 11.907 9.01866 11.907 9.24646 11.6792L14.2548 6.67085C14.4826 6.44305 14.852 6.44305 15.0798 6.67085Z"
      fill="white"
    />
  </svg>
);

export default CheckboxActiveSvg;
